import React from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import styled from 'styled-components';
import { DialogContent } from '@material-ui/core';

const MaterialModal = ({ open, handleClose, children }) => {
  return (
    <CustomModal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      disableAutoFocus
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <DialogContentWrapper>{children}</DialogContentWrapper>
      </Fade>
    </CustomModal>
  );
};

const CustomModal = styled(Modal)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const DialogContentWrapper = styled(DialogContent)`
  && {
    flex: 0 1 auto;
    padding: 0;
  }
`;

export default MaterialModal;
